var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-1994976",
    transform: "translate(-141.123 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10088",
    "data-name": "Caminho 10088",
    d: "M151.038,273.02a.255.255,0,0,0-.314.018,5.073,5.073,0,0,1-3.1,1.038,5.188,5.188,0,0,1-3.1-1.038.286.286,0,0,0-.314-.018c-2.056,1.361-3.084,4.028-3.084,7.09,0,2.113,13,2.113,13,0,0-3.062-1.028-5.729-3.085-7.09Z",
    transform: "translate(0 -250.695)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10089",
    "data-name": "Caminho 10089",
    d: "M232.749,17.993A3.818,3.818,0,1,1,228.934,14a3.907,3.907,0,0,1,3.814,3.993",
    transform: "translate(-81.311)",
    fill: "#9d9d9d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUserIcon);
export default __webpack_public_path__ + "static/media/new_user_icon.1aee4e01bdb64940ec55d2006cf13a4b.svg";
export { ForwardRef as ReactComponent };